import { Grid, InfoOutlinedIcon, SxProps, Theme, Tooltip, Typography } from '@cmg/design-system';
import React from 'react';

const infoIconStyle: SxProps<Theme> = {
  marginLeft: 0.5,
  marginTop: 0.3,
};

export type Props = {
  tooltipContent: React.ReactNode;
  label: string;
};

const InfoIconTooltip: React.FC<Props> = ({ tooltipContent, label }) => (
  <Grid container>
    <Typography>{label}</Typography>
    <Tooltip
      title={
        <Grid maxWidth={theme => theme.spacing(19.75)}>
          <Typography variant="tooltip">{tooltipContent}</Typography>
        </Grid>
      }
      placement="top"
      variant="info"
    >
      <InfoOutlinedIcon sx={infoIconStyle} fontSize="inherit" />
    </Tooltip>
  </Grid>
);

export default InfoIconTooltip;
